import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_HIGH,
  INDENT_CONTENT_COMMAND,
  KEY_TAB_COMMAND,
  OUTDENT_CONTENT_COMMAND,
} from 'lexical';
import { $getNearestNodeOfType } from '@lexical/utils';
import { ListItemNode } from '@lexical/list';

/** Tab / Shift+Tab nest and un-nest the current list item from anywhere in its
 *  text. Lexical's TabIndentationPlugin only indents when the caret is at the
 *  very start of a block and otherwise inserts a tab character, which is the
 *  right call for paragraphs but not for lists. This runs at a higher priority
 *  and only claims the key inside a list item, leaving everything else to the
 *  default plugin. */
export function ListTabIndentPlugin() {
  const [editor] = useLexicalComposerContext();
  useEffect(
    () =>
      editor.registerCommand(
        KEY_TAB_COMMAND,
        (event) => {
          const selection = $getSelection();
          if (!$isRangeSelection(selection)) return false;
          const listItem = $getNearestNodeOfType(selection.anchor.getNode(), ListItemNode);
          if (listItem === null) return false;
          event.preventDefault();
          const command = event.shiftKey ? OUTDENT_CONTENT_COMMAND : INDENT_CONTENT_COMMAND;
          editor.dispatchCommand(command, undefined);
          // Claim Tab whenever the caret is in a list item, even when the
          // indent/outdent was a no-op (already outermost): returning the
          // dispatch result would let a `false` fall through to
          // TabIndentationPlugin, which inserts a literal tab character.
          return true;
        },
        COMMAND_PRIORITY_HIGH,
      ),
    [editor],
  );
  return null;
}
